<template>
  <div class="flex flex-col h-full">
    <lerner-header :show-login-form="false" :show-shadow="false" :show-logout="true"></lerner-header>
    <section class="flex-1">
      <router-view></router-view>
    </section>
    <app-footer :pages="pages"></app-footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import PageHeader from '@/component/PageHeader';
  import LernerHeader from '@/component/Header';
  import AppFooter from '@/component/AppFooter';
  import { LOGIN_AS_STUDENT } from '@/store/actions/auth.actions';

  export default {
    name: 'index',

    components: {
      AppFooter,
      LernerHeader,
      PageHeader
    },

    computed: {
      ...mapGetters([
        'pages'
      ])
    },
    
    methods: {
      goToStudentPortal: function () {
        this.$store
            .dispatch(LOGIN_AS_STUDENT)
            .then(() => this.$router.push({name: 'student'}));
      }
    }
  };
</script>

<style lang="scss" scoped>
  .nav-portal {
    @apply bg-grey-3 py-8 px-14;
    border-radius : 0 30px 30px 0;

    .btn {
      @apply px-11;
    }

    p {
      @apply mb-0 uppercase text-white;
    }

    h6 {
      @apply uppercase leading-none text-white mb-3;
    }

    &.student-portal {
      border-radius : 0 30px 30px 0;
      @apply bg-c1-a;
    }

    &.reporting-portal {
      border-radius : 30px 0 0 30px;
      @apply bg-c1-b;
    }
  }
</style>
